// const { t } = useTranslation();

export const titles = (locale: string, t: any) => [
  { title: t('doctors_link'), href: `/${locale}/experts` },
  { title: t('news_link'), href: `/${locale}/news` },
  { title: t('help_link'), href: `/${locale}/faq` },
  { title: t('aboutas_link'), href: `/${locale}/page/about-platform` },
];

// /resend-email

export const topTitles = (locale: string, t: any) => [
  { title: t('patient_link'), href: `/${locale}/patient` },
  { title: t('doctor_link'), href: `/${locale}/doctor` },
  { title: t('med_link'), href: `/${locale}/clinics` },
];
